module.exports = __webpack_public_path__ + "static/img/20180414165936.736ae6cb.jpg";